import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bd7eaca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "about",
  name: "about"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, {
        level: 1,
        "data-aos": "fade-down"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" About Us ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_title, {
        level: 2,
        "data-aos": "fade-right"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Introduction ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", `i_${index+1}`]),
            "data-aos": "fade-up"
          }, [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 14,
                  order: index%2&&_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)===0?1:2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_paragraph, null, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, _toDisplayString(item.t1), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(item.t2), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"]),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 10,
                  order: index%2===0&&_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?2:1
                }, {
                  default: _withCtx(() => [
                    (index===2)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "image",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$Store.Overseas().openModal('modalImage',$data.href.ImageCertificate)))
                        }, _hoisted_5))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["order"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}